import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const ComparingDateInfo = (
  {
    selectedComparingDate,
    selectedZone,
    selectedTimeZone,
  },
) => {
  if (!selectedComparingDate) return null;
  return (
    <div className="c-comparing-date-info">
      {
        selectedZone && selectedComparingDate && selectedTimeZone &&
        <Fragment>
          {selectedZone}
          <br />
          {moment(selectedComparingDate)
            .utcOffset(selectedTimeZone)
            .format('DD/MM/YYYY HH:mm (dddd)')}
        </Fragment>
      }
    </div>
  );
};

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

ComparingDateInfo.propTypes = {
  // Selected product
  selectedProduct: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // Selected comparing year option
  selectedComparingYear: optionPropType,
  // Selected comparing month option
  selectedComparingMonth: optionPropType,
  // Selected comparing day option
  selectedComparingDay: optionPropType,
  // Selected comparing hour option
  selectedComparingHour: optionPropType,
  selectedZone: PropTypes.string,
  selectedTimeZone: PropTypes.number,
};

ComparingDateInfo.defaultProps = {
  selectedProduct: null,
  selectedComparingYear: null,
  selectedComparingMonth: null,
  selectedComparingDay: null,
  selectedComparingHour: null,
  selectedComparingDate: null,
  selectedZone: null,
  selectedTimeZone: null,
};

export default ComparingDateInfo;



// WEBPACK FOOTER //
// ./src/components/forecast-demo/components/comparing-date-info/component.js